export enum MandatedIdentificationType {
  RespondentMember = 'RespondentMember',
  MandatedRepresentative = 'MandatedRepresentative',
}

export class MandatedIdentification {

  constructor(
    public type: MandatedIdentificationType,
    public name: string,
    public email: string,
  ) { }

}